<template>
    <span>
        <app-login-form
            :api_error="apiError"
            @cancelled="onFormCancelled"
            @submitted="onFormSubmitted"
        >
        </app-login-form>

        <b-toast id="toast-invalid" solid variant="danger">
            <div
                class="d-flex flex-grow-1 align-items-baseline"
                slot="toast-title"
            >
                <strong class="mr-auto">Cannot Login</strong>
            </div>
            Invalid Login. Please check your details.
        </b-toast>

        <b-toast id="toast-server-down" solid variant="danger">
            <div
                class="d-flex flex-grow-1 align-items-baseline"
                slot="toast-title"
            >
                <strong class="mr-auto">Cannot Login</strong>
            </div>
            The Server is not responding, please wait a few minutes and try
            again. If this continues please contact support
            <a href="mailto:support@ocom.com.au" target="email"
                >support@ocom.com.au</a
            >
        </b-toast>
    </span>
</template>

<script>
/* eslint-disable no-unused-vars */
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { localUrls } from "../urls";
import LoginForm from "./LoginForm.vue";

export default {
    components: {
        appLoginForm: LoginForm,
    },

    props: {
        redirectTo: String,
        dontRedirect: Boolean,
    },
    data() {
        return {
            // whether any operations are currently running
            working: false,

            // error messages returned from API (e.g. invalid login)
            apiError: null,
        };
    },

    methods: {
        /**
         * Attempts to submit the current user data to the API to login.
         */
        onFormSubmitted(value, event) {
            const user = {
                username: value.username,
                password: value.password,
            };

            this.working = true;
            this.apiError = null;

            this.doLogin(user).then(
                () => {
                    this.working = false;
                    this.doRedirect();
                },
                (error) => {
                    if (!error.response) {
                        this.$bvToast.show("toast-server-down");
                    } else {
                        this.$bvToast.show("toast-invalid");
                        this.serverErrors = _.clone(error.response.data);
                        this.apiError = error.response.data;
                        this.working = false;
                    }
                }
            );
        },

        doRedirect() {
            if (this.dontRedirect) {
                return; // Do nothing..
            }

            if (this.redirectTo) {
                this.$router.push(this.redirectTo);
            } else {
                this.$router.go(-1); // previous page..
            }
        },

        onFormCancelled(value, event) {
            this.$router.push(localUrls.accountCreate);
        },

        ...mapActions("AuthModule", ["doLogin"]),
    },
    computed: {
        ...mapGetters("AuthModule", ["isLoggedIn"]),
    },

    created() {
        if (this.isLoggedIn) {
            this.doRedirect();
        }

        console.log("Logging in....");
    },
};
</script>
